import * as React from 'react'
import Tooltip from 'LuxKit/Tooltip'
import Group from 'components/utils/Group'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  children: React.ReactNode
  tooltip?: string
}

function ExperienceTicketInfoMessage(props: Props) {
  return (
    <Tooltip description={props.tooltip} disabled={!props.tooltip}>
      <Group direction="horizontal" gap={2}>
        <BodyText colour="neutral-two" variant="small">{props.children}</BodyText>
        {!!props.tooltip && <LineInfoCircleIcon size="XS" />}
      </Group>
    </Tooltip>
  )
}

export default ExperienceTicketInfoMessage
